'use strict';

var NetSpillRateModalDirective = function NetSpillRateModalDirective() {
  return {
    restrict: 'E',
    template: require('../templates/net-spill-rate-modal.html'),
    scope: {
      modalIdentifier: '@'
    },
    link: function link($scope, element) {
      $scope.showChart = false;
      element.on('shown.bs.modal', function () {
        $scope.showChart = true;
        $scope.$digest();
      }).on('hidden.bs.modal', function () {
        $scope.showChart = false;
        $scope.$digest();
      });
    }
  };
};
NetSpillRateModalDirective.$inject = [];
module.exports = NetSpillRateModalDirective;